import React from "react";
import { Container, Typography, Card, CardContent } from "@mui/material";
import logo from "./logo.svg";
import valleLogo from "../src/assets/valleGroup.png";
import "./App.css";

function App() {
  return (
    <Container
      maxWidth="md"
      sx={{
        textAlign: "center",
        py: 4,
        backgroundColor: "#f4f6f8",
        borderRadius: 2,
        boxShadow: 3,
      }}
    >
      <img
        src={valleLogo}
        alt="Evangelize Logo"
        style={{ width: "100%", marginBottom: "20px" }}
      />
      <Typography variant="h4" fontWeight="bold" color="primary" gutterBottom>
        Termos de Uso do Aplicativo Evangelize
      </Typography>
      <Typography variant="subtitle1" color="textSecondary" gutterBottom>
        Última Atualização: 29/01/2025
      </Typography>

      <Card
        sx={{ p: 3, boxShadow: 5, borderRadius: 3, backgroundColor: "#ffffff" }}
      >
        <CardContent sx={{ textAlign: "left" }}>
          <Typography variant="body1" paragraph>
            Seja bem-vindo ao <strong>Evangelize</strong>, Seja bem-vindo ao
            Evangelize, um aplicativo desenvolvido para evangelização cristã,
            orientado pela fé católica. Estes Termos de Uso regulam a utilização
            do aplicativo e devem ser lidos com atenção antes de acessar ou usar
            os serviços fornecidos. Ao utilizar o Evangelize, você concorda
            integralmente com as condições aqui descritas. Caso não concorde,
            pedimos que não utilize o aplicativo.
          </Typography>

          <Typography
            variant="body1"
            fontWeight="bold"
            color="#f7b440"
            gutterBottom
          >
            1. Objetivo do Evangelize
          </Typography>
          <Typography variant="body2" paragraph>
            O Evangelize tem como missão evangelizar e orientar usuários sobre a
            fé cristã católica, oferecendo conteúdos educativos, motivacionais e
            espirituais.  <br />O aplicativo disponibiliza vídeos, músicas, mensagens e
            um sistema inovador de inteligência artificial que responde dúvidas
            sobre a fé cristã, tudo de forma gratuita.
          </Typography>

          <Typography
            variant="body1"
            fontWeight="bold"
            color="#f7b440"
            gutterBottom
          >
            2. Aceitação dos Termos
          </Typography>
          <Typography variant="body2" paragraph>
            Ao criar uma conta ou utilizar qualquer funcionalidade do
            Evangelize, o usuário aceita integralmente os presentes Termos de
            Uso, bem como todas as futuras atualizações que possam ocorrer.  <br />A
            continuidade no uso do aplicativo após alterações implica a
            concordância com os novos termos.
          </Typography>

          <Typography
            variant="body1"
            fontWeight="bold"
            color="#f7b440"
            gutterBottom
          >
            3. Acesso e Elegibilidade
          </Typography>
          <Typography variant="body2" paragraph>
            • O Evangelize está disponível para todas as idades, sendo
            necessário o fornecimento de informações pessoais, como nome
            completo, e-mail e localização, para a criação de uma conta.  <br />• O uso
            do aplicativo requer um dispositivo com acesso à internet. Eventuais
            custos relacionados à conexão são de responsabilidade exclusiva do
            usuário.
          </Typography>

          <Typography
            variant="body1"
            fontWeight="bold"
            color="#f7b440"
            gutterBottom
          >
            4. Cadastro e Responsabilidades do Usuário
          </Typography>
          <Typography variant="body2" paragraph>
            Para acessar os recursos completos do Evangelize, o usuário deve
            criar uma conta fornecendo informações precisas e atualizadas. É
            proibido:  <br />• Usar informações falsas ou enganosas ao criar uma conta.
            <br />
            • Permitir que terceiros utilizem a sua conta. <br /> • Compartilhar
            credenciais de acesso com outras pessoas. O usuário é responsável
            pela segurança de suas credenciais de login. O Evangelize não se
            responsabiliza por acessos não autorizados decorrentes de
            negligência do usuário.
          </Typography>

          <Typography
            variant="body1"
            fontWeight="bold"
            color="#f7b440"
            gutterBottom
          >
            5. Uso Permitido e Restrições
          </Typography>
          <Typography variant="body2" paragraph>
            O Evangelize oferece conteúdos e ferramentas com a finalidade
            exclusiva de promover a evangelização e o aprendizado da fé cristã
            católica.  <br />O uso do aplicativo deve seguir estas regras: <br /> • É
            permitido: o Reproduzir vídeos, músicas e mensagens disponíveis na
            plataforma.  <br />o Compartilhar imagens pré-definidas pelo aplicativo em
            redes sociais ou outros meios. <br /> • É proibido: o Alterar, copiar,
            distribuir ou modificar qualquer conteúdo disponibilizado sem
            autorização prévia da Valle Group Soluções e Entretenimento Eirelli
            ME. <br /> o Utilizar o aplicativo para promover discurso de ódio, conteúdo
            ofensivo ou contrário à moral cristã. o Praticar atividades que
            violem leis locais, nacionais ou internacionais.  <br /> Ao Tentar invadir,
            hackear ou prejudicar o funcionamento do aplicativo.  <br />Qualquer
            violação pode resultar na suspensão ou exclusão definitiva da conta
            do usuário, sem aviso prévio.
          </Typography>

          <Typography
            variant="body1"
            fontWeight="bold"
            color="#f7b440"
            gutterBottom
          >
            6. Direitos Autorais e Propriedade Intelectual
          </Typography>
          <Typography variant="body2" paragraph>
            O Evangelize e todo o seu conteúdo, incluindo textos, imagens,
            vídeos, músicas e a inteligência artificial, são protegidos por leis
            de propriedade intelectual. <br /> Todos os direitos são reservados à Valle
            Group Soluções e Entretenimento Eirelli ME, titular exclusiva de
            tais direitos.  <br /> O aplicativo também oferece acesso a vídeos e músicas
            hospedados em plataformas de terceiros, como YouTube, Spotify ou
            outras plataformas freemium. Esses conteúdos permanecem sob a
            propriedade e os direitos autorais dos seus respectivos criadores ou
            proprietários.  <br /> O uso destes conteúdos pelo Evangelize está sujeito
            às políticas das respectivas plataformas. Os usuários:  <br /> • Podem
            compartilhar imagens pré-definidas. • Podem reproduzir áudios e
            vídeos no aplicativo.  <br />• Não podem copiar, alterar ou distribuir os
            conteúdos disponibilizados sem autorização do Evangelize ou do
            proprietário do conteúdo.  <br />A reprodução não autorizada de qualquer
            conteúdo será tratada conforme a legislação vigente.
          </Typography>

          <Typography
            variant="body1"
            fontWeight="bold"
            color="#f7b440"
            gutterBottom
          >
            7. Contribuições e Modelo de Gratuidade
          </Typography>
          <Typography variant="body2" paragraph>
            O Evangelize é inteiramente gratuito para todos os usuários. <br /> No
            entanto, os usuários têm opções para contribuir com o projeto de
            forma voluntária: <br /> • Doações mensais recorrentes: <br /> É possível
            configurar contribuições automáticas via cartão de crédito para
            apoiar o projeto mensalmente. <br /> • Doações pontuais: Usuários que
            desejarem doar valores maiores ou específicos podem entrar em
            contato diretamente com a equipe do Evangelize por meio do email
            <strong> contato@vallegroup.com.br</strong>.  <br />As doações são destinadas exclusivamente
            à manutenção e aprimoramento do aplicativo, não conferindo
            privilégios ou benefícios extras ao doador.
          </Typography>

          <Typography
            variant="body1"
            fontWeight="bold"
            color="#f7b440"
            gutterBottom
          >
            8. Privacidade e Segurança
          </Typography>
          <Typography variant="body2" paragraph>
            O Evangelize valoriza a privacidade dos seus usuários.  <br />Dados como
            nome, e-mail e localização são coletados exclusivamente para fins de
            personalização, envio de newsletters e comunicação.  <br />Senhas são
            criptografadas para proteção. <br /> Para mais informações, consulte nossa
            Política de Privacidade.
          </Typography>

          <Typography
            variant="body1"
            fontWeight="bold"
            color="#f7b440"
            gutterBottom
          >
            9. Limitação de Responsabilidade
          </Typography>
          <Typography variant="body2" paragraph>
            O Evangelize não garante que: <br /> • O aplicativo estará disponível sem
            interrupções ou erros.  <br />• Os conteúdos atenderão às expectativas ou
            objetivos específicos dos usuários.
          </Typography>

          <Typography
            variant="body1"
            fontWeight="bold"
            color="#f7b440"
            gutterBottom
          >
            10. Suspensão e Encerramento
          </Typography>
          <Typography variant="body2" paragraph>
            A Valle Group pode, a seu critério, suspender ou encerrar o acesso
            de um usuário ao aplicativo em caso de:  <br /> • Violação destes Termos de
            Uso.  <br />• Atividade considerada prejudicial ao aplicativo ou à
            comunidade. <br /> O usuário pode encerrar sua conta a qualquer momento,
            mediante solicitação via e-mail para
            <strong> contato@vallegroup.com.br.</strong>
          </Typography>

          <Typography
            variant="body1"
            fontWeight="bold"
            color="#f7b440"
            gutterBottom
          >
            11. Alterações nos Termos de Uso
          </Typography>
          <Typography variant="body2" paragraph>
            Estes Termos podem ser atualizados periodicamente para refletir
            mudanças no aplicativo ou em requisitos legais.  <br />Alterações serão
            notificadas por e-mail cadastrado, e o uso contínuo do aplicativo
            após a notificação implica a aceitação dos novos termos.
          </Typography>

          <Typography
            variant="body1"
            fontWeight="bold"
            color="#f7b440"
            gutterBottom
          >
            12. Foro e Legislação Aplicável
          </Typography>
          <Typography variant="body2" paragraph>
            Este documento será regido e interpretado de acordo com as leis
            brasileiras.  <br />Para quaisquer disputas, fica eleito o foro da comarca
            de Belo Horizonte, Minas Gerais, com exclusão de qualquer outro, por
            mais privilegiado que seja.
          </Typography>

          <Typography
            variant="body1"
            fontWeight="bold"
            color="#f7b440"
            gutterBottom
          >
            13. Contato
          </Typography>
          <Typography variant="body2" paragraph>
            Para dúvidas, sugestões, reclamações ou para excluir seus dados, entre em contato pelo
            e-mail: <strong>contato@vallegroup.com.br</strong>.
          </Typography>
        </CardContent>
      </Card>
    </Container>
  );
}

export default App;
